var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"alt":"Vue logo","src":require("./assets/covid-19.png")}}),_c('div',{staticClass:"date"},[_vm._v(" "+_vm._s(_vm._f("moment")(new Date(),"llll"))+" ")]),_c('Api')],1)}
var staticRenderFns = []

export { render, staticRenderFns }